import PropTypes from 'prop-types';
import React from 'react';
import { FormattedRelative } from 'react-intl';
import DateTimeToolTip from './DateTimeToolTip';

export default class RelativeTime extends React.Component {
    render() {
        return (
            <DateTimeToolTip date={this.props.date} format={this.props.absoluteTimeFormat}>
                <FormattedRelative value={this.props.date} />
            </DateTimeToolTip>
        );
    }
}

RelativeTime.propTypes = {
    date: PropTypes.any.isRequired,
    absoluteTimeFormat: PropTypes.string,
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/RelativeTime.jsx